module.exports = __webpack_public_path__ + "static/media/salud-svg-purple.9aee05ce.svg";